// ponytail: crests live in public/teams (downloaded from OpenLigaDB / Wikimedia, no hotlinking).
// Unknown club -> full name, no logo.
const TEAMS: Record<string, { short: string; logo: string }> = {
  "1. FC Köln": { short: "KOE", logo: "koe.svg" },
  "1. FC Union Berlin": { short: "FCU", logo: "fcu.svg" },
  "1899 Hoffenheim": { short: "TSG", logo: "tsg.png" },
  "Bayer 04 Leverkusen": { short: "B04", logo: "b04.png" },
  "Bor. Mönchengladbach": { short: "BMG", logo: "bmg.png" },
  "Borussia Dortmund": { short: "BVB", logo: "bvb.png" },
  "Eintracht Frankfurt": { short: "SGE", logo: "sge.png" },
  "FC Augsburg": { short: "FCA", logo: "fca.png" },
  "FC Bayern München": { short: "FCB", logo: "fcb.svg" },
  "FC Schalke 04": { short: "S04", logo: "s04.png" },
  "FSV Mainz 05": { short: "M05", logo: "m05.svg" },
  "Hamburger SV": { short: "HSV", logo: "hsv.svg" },
  "RB Leipzig": { short: "RBL", logo: "rbl.png" },
  "SC Freiburg": { short: "SCF", logo: "scf.png" },
  "SC Paderborn 07": { short: "SCP", logo: "scp.svg" },
  "SV Elversberg": { short: "SVE", logo: "sve.png" },
  "VfB Stuttgart": { short: "VFB", logo: "vfb.png" },
  "Werder Bremen": { short: "SVW", logo: "svw.svg" },
};

export const shortName = (team: string) => TEAMS[team]?.short || team;

export const teamLogo = (team: string) =>
  TEAMS[team] ? `${process.env.PUBLIC_URL}/teams/${TEAMS[team].logo}` : undefined;
